import React, { Fragment, useState, useRef, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";

const ManualInput = ({ id, endpoint }) => {
  const [errMessage, setErrMessage] = useState();

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    const formData = Object.fromEntries(new FormData(form));
    const { referenceNo } = formData;
    setErrMessage(undefined);
    axios
      .post(endpoint, { id, scanned: referenceNo })
      .then((res) => {
        Swal.fire({
          title: "Success",
          text: referenceNo,
          icon: "success",
          timer: 3000,
          timerProgressBar: true,
        });
      })
      .catch((err) => {
        setErrMessage(err.response.data.errors?.base);
        Swal.fire({
          title: referenceNo,
          text: err.response.data.errors?.base,
          icon: "error",
          timer: 3000,
          timerProgressBar: true,
        });
        console.log(err.response.data?.errors);
      });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3" controlId="formBasicEmail">
        <Form.Label>Reference #</Form.Label>
        <Form.Control
          size="lg"
          type="text"
          placeholder="Enter Reference #"
          name="referenceNo"
          isInvalid={errMessage}
        />
        <Form.Control.Feedback type="invalid">
          {errMessage}
        </Form.Control.Feedback>
      </Form.Group>

      <Button variant="primary" type="submit">
        Assign
      </Button>
    </Form>
  );
};

export default ManualInput;
